(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../../../enums/metrics.js').dataType,
            require('../../../enums/metrics.js').collection,
            require('../../../enums/metrics.js').sources,
            require('../../../enums/metrics.js').sourceDetails,
            require('../enums/dataSourceFilterGroupIds.js')
        );

    } else {
        RivalIQ.module('metrics.new.dataSources', function (dataSources) {
            dataSources.TwitterPublicPresence = exportFn(
                RivalIQ.enums.dataType,
                RivalIQ.enums.collection,
                RivalIQ.enums.sources,
                RivalIQ.enums.sourceDetails,
                RivalIQ.metrics.new.enums.DataSourceFilterGroupIds
            );
        });
    }

    function exportFn(dataType, collection, sources, sourceDetails, DataSourceFilterGroupIds) {
        return {
            name: 'Twitter public presence data by day',
            channelName: sourceDetails[sources.TWITTER].name,
            postName: sourceDetails[sources.TWITTER].postName,

            storageDimensions: [
                'companyId',
                'day'
            ],

            availableDimensions: [
                'companySetId',
                'week',
                'month'
            ],

            fields: {
                audience: {
                    name: 'Followers',
                    collection: collection.AUDIENCE,
                    dataType: dataType.INTEGER
                },
                following: {
                    name: 'Following',
                    collection: collection.AUDIENCE,
                    dataType: dataType.INTEGER
                },
                followers_to_following: {
                    name: 'Followers / Following Ratio',
                    collection: collection.AUDIENCE,
                    dataType: dataType.NUMERIC
                },
                lifetime_count: {
                    name: 'Lifetime Tweets',
                    collection: collection.ACTIVITY,
                    dataType: dataType.INTEGER
                },
                lifetime_likes: {
                    name: 'Lifetime Likes',
                    collection: collection.ACTIVITY,
                    dataType: dataType.INTEGER
                },
                listed_count: {
                    name: 'Listed',
                    collection: collection.ACTIVITY,
                    dataType: dataType.INTEGER
                }
            },

            supportedFilterGroups: [
                DataSourceFilterGroupIds.company,
                DataSourceFilterGroupIds.timePeriod
            ]
        };
    }
})();
